import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap, catchError, mergeMap } from 'rxjs/operators';
import { ServersService } from '../services';
import {
  ServersLoadDoneAction,
  ServersLoadFailedAction,
  ServersActionTypes,
  ServersLoadAction,
} from '@cue-admin/shared-data';

function getStatusCode(error: unknown): string | null {
  if (typeof error === 'object' && error !== null && 'status' in error) {
    return String(error.status);
  }

  return null;
}

@Injectable()
export class ServersEffects {
  private serversService = inject(ServersService);
  private actions$ = inject(Actions);

  effectLoad$ = createEffect(() =>
    this.actions$.pipe(
      ofType<ServersLoadAction>(ServersActionTypes.Load),
      switchMap(() =>
        this.serversService.actionLoad().pipe(
          mergeMap((action) => {
            return [
              new ServersLoadDoneAction(
                action.data ?? {
                  state: {},
                  servers: null,
                }
              ),
            ];
          }),
          catchError((err: unknown) => {
            return [new ServersLoadFailedAction({ state: { errorCode: getStatusCode(err) } })];
          })
        )
      )
    )
  );
}
